// src/pages/Login/NiceLoginForm.jsx
import React from "react";
import { Box, TextField, Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

const inputStyles = {
  "& .MuiInputLabel-root": {
    color: "rgba(15,17,21,0.7)",
    fontWeight: 500,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "rgba(15,17,21,0.95)",
  },
  "& .MuiFilledInput-root": {
    borderRadius: 2,
    backgroundColor: "rgba(248,250,252,0.92)",
    boxShadow: "0 2px 10px rgba(0,0,0,.06) inset",
    backdropFilter: "blur(10px)",
    transition:
      "background-color .2s, box-shadow .2s, transform .15s, border-color .15s",
    border: "1px solid rgba(15,17,21,0.08)",
    color: "#0f1115",
    "& input": {
      color: "#0f1115",
      fontWeight: 500,
    },
  },
  "& .MuiFilledInput-root.Mui-focused": {
    backgroundColor: "rgba(255,255,255,0.98)",
    boxShadow: "0 4px 16px rgba(15,17,21,.16)",
    transform: "translateY(-1px)",
    borderColor: "rgba(15,17,21,0.22)",
  },
  "& .MuiFilledInput-root:hover": {
    backgroundColor: "rgba(248,250,252,0.98)",
  },
};

const NiceLoginForm = ({ handleLogin, navigate, loading }) => {
  const { t } = useTranslation();

  return (
    <Box
      component="form"
      onSubmit={handleLogin}
      noValidate
      sx={{ mt: 1, width: "100%" }}
    >
      <Stack spacing={1.8}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="username"
          label={t("login_form.username")}
          name="username"
          autoComplete="username"
          autoFocus
          variant="filled"
          InputProps={{
            disableUnderline: true,
          }}
          sx={inputStyles}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label={t("login_form.password")}
          type="password"
          id="password"
          autoComplete="current-password"
          variant="filled"
          InputProps={{
            disableUnderline: true,
          }}
          sx={inputStyles}
        />

        <Button
          type="submit"
          fullWidth
          disableElevation
          disabled={loading}
          sx={{
            mt: 2.5,
            mb: 1.5,
            py: 1.05,
            borderRadius: 999,
            textTransform: "none",
            fontWeight: 700,
            letterSpacing: 0.4,
            color: "#0f1115",
            background: "rgba(255,255,255,0.92)",
            border: "1px solid rgba(255,255,255,.55)",
            backdropFilter: "blur(10px)",
            boxShadow: "0 10px 26px rgba(0,0,0,.18)",
            transition: "all .2s ease",
            "&:hover": {
              background: "rgba(255,255,255,0.98)",
              boxShadow: "0 12px 30px rgba(0,0,0,.22)",
            },
            "&.Mui-disabled": {
              color: "rgba(0,0,0,.45)",
              background: "rgba(255,255,255,0.5)",
              borderColor: "rgba(255,255,255,.4)",
              boxShadow: "none",
            },
          }}
        >
          {t("login_form.sign_in")}
        </Button>
      </Stack>
    </Box>
  );
};

export default NiceLoginForm;
